import { isStrictMiniApp, isStrictWechatMiniProgram } from '../utils';
export function getWXVideoContext(id) {
    if (typeof wx !== 'undefined') {
        let _internal;
        if (document && document.getElementById && document.getElementById(id)) {
            _internal = document.getElementById(id)._internal;
        }
        return wx.createVideoContext(id, _internal);
    }
    return null;
}
export function getMiniappVideoContext(id) {
    if (typeof my !== 'undefined') {
        return my.createVideoContext(id);
    }
    return null;
}
export function getContexts(refs, sliderPrefixId) {
    return refs.map((ref, index) => {
        const id = `${sliderPrefixId}-${index}`;
        let node = ref;
        if (isStrictMiniApp) {
            node = getMiniappVideoContext(id);
        }
        else if (isStrictWechatMiniProgram) {
            node = getWXVideoContext(id);
        }
        return node;
    });
}
export function pauseAll(contexts) {
    contexts.forEach((ctx) => {
        if (ctx.pause) {
            ctx.pause();
        }
    });
}
export function play(contexts, index) {
    if (contexts && contexts[index] && contexts[index].play) {
        contexts[index].play();
    }
}
